import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, InputNumber, Table } from 'antd';
import { getConsignmentOrderMovements } from '../../../../appRedux/actions';
import { formatPrice } from '../../../../util/formatPrice';

export const ConsignmentOrderMovement = ({
  disabled = false,
  ConsignmentOrderId,
  isRefund = false,
}) => {
  const dispatch = useDispatch();
  const { consignmentOrderMovement } = useSelector(
    (state) => state.consignmentOrder
  );
  const [productDetails, setProductDetails] = useState([]);

  useEffect(() => {
    if (ConsignmentOrderId) {
      dispatch(getConsignmentOrderMovements(ConsignmentOrderId));
    }
  }, [dispatch, ConsignmentOrderId]);

  useEffect(() => {
    if (!consignmentOrderMovement?.length) return;

    const details = consignmentOrderMovement.map((movement) => {
      const totalSold = Number(movement.totalSold);
      const totalBilled = Number(movement.totalBilled);
      const totalRefunded = Number(movement.totalRefunded);
      const totalRecive = Number(movement.consignedQuantity);

      const maxToBill = Math.max(0, totalSold - totalBilled);
      const maxToRefund = Math.max(0, totalRecive - totalSold - totalRefunded);

      return {
        key: movement.consignmentOrderProductId,
        productName: movement.productName,
        receivedQuantity: movement.consignedQuantity,
        soldQuantity: movement.totalSold,
        refundQuantity: movement.totalRefunded,
        billedQuantity: movement.totalBilled,
        toBillQuantity: maxToBill,
        toRefundQuantity: maxToRefund,
        price: formatPrice(movement.price),
      };
    });

    setProductDetails(details);
  }, [consignmentOrderMovement]);

  const columns = [
    {
      title: 'Producto',
      dataIndex: 'productName',
      align: 'center',
    },
    { title: 'Precio', dataIndex: 'price', align: 'center' },
    {
      title: 'Cant. Recibida',
      dataIndex: 'receivedQuantity',
      align: 'center',
    },
    {
      title: 'Cant. Vendida',
      dataIndex: 'soldQuantity',
      align: 'center',
    },
    {
      title: 'Cant. Devuelta',
      dataIndex: 'refundQuantity',
      align: 'center',
    },
    {
      title: 'Cant. Facturada',
      dataIndex: 'billedQuantity',
      align: 'center',
    },
    {
      title: isRefund ? 'Cant. a Devolver' : 'Cant. a Facturar',
      align: 'center',
      render: (_, record) => (
        <Form.Item
          name={['movements', record.key]}
          initialValue={0}
          style={{ marginBottom: 0 }}
        >
          <InputNumber
            style={{ width: 80, textAlign: 'center' }}
            min={0}
            max={isRefund ? record.toRefundQuantity : record.toBillQuantity}
            disabled={disabled}
          />
        </Form.Item>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={productDetails}
      pagination={false}
      bordered
    />
  );
};
